import { defineComponent as _defineComponent } from 'vue'
import { LightGallery } from 'vue-light-gallery';
import { nextTick, onMounted, ref } from "vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const images = ref<{ title: string, url: string }[]>([])
const index = ref(null)
// eslint-disable-next-line no-undef
const scrollers = ref<NodeListOf<HTMLElement>>()
const count = ref('')


const fetchCounter = async (): Promise<string> => {
    try {
        const response = await fetch('https://mb-grillservice.de/counter.php'); // Adjust the path if necessary
        if (!response.ok) {
            console.error('Error fetching counter');
            return '300'
        }
        const counter = await response.text();
        console.log(counter)
        return counter; // Return the array of filenames
    } catch (error) {
        console.error('Error fetching counter:', error);
        return '300'
    }
}
const fetchGallery = async (): Promise<string[]> => {
    try {
        const response = await fetch('https://mb-grillservice.de/getGallery.php'); // Adjust the path if necessary
        if (!response.ok) {
            return []
        }
        const filenames = await response.json(); // Parse the JSON response
        return filenames; // Return the array of filenames
    } catch (error) {
        console.error('Error fetching filenames:', error);
        return []
    }
}

const logRef = async (ref: string) => {
    try {
        const response = await fetch('https://mb-grillservice.de/ref.php?ref=' + ref); // Adjust the path if necessary
        if (!response.ok) {
            console.error('Error fetching ref');
            return '300'
        }

    } catch (error) {
        console.error('Error fetching ref:', error);
        return '300'
    }
}
onMounted(async () => {
    const urls = await fetchGallery()
    urls.forEach((url: string) => {
        images.value.push({
            title: '',
            url: url
        })
    })

    nextTick(() => {
        // Select all elements with the class "scroller"
// eslint-disable-next-line no-undef
        scrollers.value = document.querySelectorAll<HTMLElement>(".scroller");

// Check if the user has opted for reduced motion
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            addAnimation();
        }
    })

    count.value = await fetchCounter()

    if(router.currentRoute.query.ref) {
        await logRef(String(router.currentRoute.query.ref))
    }
})

function addAnimation(): void {

    scrollers.value?.forEach((scroller: HTMLElement) => {
        // Add data-animated="true" to every `.scroller` on the page
        scroller.setAttribute("data-animated", "true");
    });
}

return { __sfc: true,images, index, scrollers, count, fetchCounter, fetchGallery, logRef, addAnimation, LightGallery }
}

})